var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High risk warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2894 5.51068C10.2746 5.44622 10.2439 5.38644 10.2003 5.3367C10.1567 5.28697 10.1014 5.24884 10.0394 5.22572L7.15983 4.14583L7.88973 0.481218C7.90652 0.396331 7.89567 0.3083 7.85878 0.230026C7.8219 0.151752 7.76091 0.0873514 7.68476 0.0462642C7.60785 0.00535505 7.51958 -0.00898161 7.43369 0.00548574C7.34779 0.0199531 7.26908 0.0624128 7.20982 0.126256L1.61058 6.12562C1.5647 6.17322 1.53151 6.23158 1.51404 6.29535C1.49657 6.35911 1.49538 6.42624 1.5106 6.49058C1.52625 6.55469 1.55715 6.61408 1.60066 6.66369C1.64418 6.71331 1.69904 6.75168 1.76056 6.77555L4.64017 7.85544L3.91027 11.52C3.89348 11.6049 3.90433 11.693 3.94122 11.7712C3.9781 11.8495 4.03909 11.9139 4.11524 11.955C4.17264 11.984 4.23593 11.9994 4.30022 12C4.35455 12.0002 4.40834 11.9892 4.45823 11.9677C4.50812 11.9462 4.55304 11.9147 4.59018 11.875L10.1894 5.87565C10.2353 5.82804 10.2685 5.76968 10.286 5.70592C10.3034 5.64216 10.3046 5.57503 10.2894 5.51068Z",
    fill: "#E45C51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningRed);
export default __webpack_public_path__ + "static/media/lightning-red.69fef4b6ebd6e2f6f76130dc522fc559.svg";
export { ForwardRef as ReactComponent };